<template>
  <div class="ScholarshipArea">
    <!-- 首頁圖 -->
    <div ref="first_tit" class="banner">
      <h1>{{ $t("nav.winning_student") }}</h1>
    </div>
    <!-- 獲得者內容 -->
    <div class="content-container">
      <!-- 按鈕導航 -->
      <div class="btn-nav">
        <CoButton @click.native="scollTo($refs.first_tit)" arrow>{{
          winnerData.title
        }}</CoButton>
        <CoButton @click.native="scollTo($refs.second_tit)" arrow>{{
          winnerData.submin_tit
        }}</CoButton>
      </div>
      <!-- 標題 -->
      <div class="title">
        <span>{{ $t("awardees.title") }}</span>
      </div>
      <p>{{ winnerData.tips }}</p>
      <!-- 獲獎者 -->
      <div v-show="false" class="winners-container">
        <div class="winners-top">
          <div
            v-for="(item, index) in winnerData.period"
            :key="index"
            :class="['date-btn', { active: index === 0 }]"
          >
            {{ item }}
          </div>
        </div>
        <ul class="winners-info">
          <li v-for="(item, index) in winnerData.peopleInfo" :key="index">
            <div class="winners-info-photo">
              <img :src="item.photo" />
            </div>
            <div class="winners-info-content">
              <p class="name">{{ item.name }}</p>
              <span class="source">{{ item.source }}</span>
              <div @click="openWindow(item.story)" class="more-info">
                {{ $t("btn_list.his_story") }}
              </div>
            </div>
          </li>
        </ul>
        <div class="winners-bottom">
          <div class="more-btn">{{ $t("btn_list.show_more") }}</div>
        </div>
      </div>
      <!-- 遞交报告 -->
      <div ref="second_tit" class="content-container submit-container-bg">
        <div class="submit-container">
          <div class="title">
            <span>{{ $t("awardees.submin_tit") }}</span>
          </div>
          <p class="date">{{ $t("awardees.submin_per") }}</p>
          <!-- <p class="date">{{ $t("scholarship.test_span") }}</p> -->
          <div class="submit-item-container">
            <div class="submit-item">
              <div class="title">{{ winnerData.submit[0].tit }}</div>
              <div class="border"></div>
              <p class="con">{{ winnerData.submit[0].con }}</p>
              <p class="con">{{ winnerData.submit[0].con_tit }}</p>
              <i class="list-mark"></i>
              <p class="con">{{ winnerData.submit[0].con_txt1 }}</p>
              <i class="list-mark"></i>
              <p class="con">{{ winnerData.submit[0].con_txt2 }}</p>
              <i class="list-mark"></i>
              <p class="con">{{ winnerData.submit[0].con_txt3 }}</p>
              <div
                @click="openWindow(winnerData.submit[0].toLink)"
                class="tag tag1"
              >
                {{ winnerData.submit[0].btn }}
              </div>
            </div>
            <div class="submit-item">
              <div class="title">{{ winnerData.submit[1].tit }}</div>
              <div class="border"></div>
              <p class="con">{{ winnerData.submit[1].con }}</p>
              <p class="con">{{ winnerData.submit[1].con_tit }}</p>
              <i class="list-mark"></i>
              <p class="con">{{ winnerData.submit[1].con_txt1 }}</p>
              <i class="list-mark"></i>
              <p class="con">{{ winnerData.submit[1].con_txt2 }}</p>
              <p
                class="con"
                v-show="this.$i18n.locale === 'zh_hk'"
                style="marginleft: 30px"
              >
                {{ winnerData.submit[1].con_txt21 }}
              </p>
              <p
                class="con"
                v-show="this.$i18n.locale === 'zh_hk'"
                style="marginleft: 30px"
              >
                {{ winnerData.submit[1].con_txt22 }}
              </p>
              <i class="list-mark"></i>
              <p class="con">{{ winnerData.submit[1].con_txt3 }}</p>
              <i class="list-mark"></i>
              <p class="con">{{ winnerData.submit[1].con_txt4 }}</p>
              <div @click="openWindow(winnerData.submit[1].toLink)" class="tag">
                {{ winnerData.submit[1].btn }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CommonSlogan />
  </div>
</template>

<script>
import CoButton from "../components/co-button/co-button.vue";
import CommonSlogan from "../components/CommonSlogan.vue";
export default {
  name: "ScholarshipArea",
  data() {
    return {};
  },
  components: { CommonSlogan, CoButton },
  methods: {
    // 导航按钮
    scollTo(obj) {
      window.scrollTo({
        top: obj.offsetTop,
      });
    },
    openWindow(href) {
      if (href) {
        window.open(href, "_blank");
      }
    },
  },
  computed: {
    winnerData: function () {
      return this.$t("awardees");
    },
  },
};
</script>

<style scoped lang="scss">
.ScholarshipArea {
  .banner {
    background-image: url("../assets/img/winning/banner.jpg");
  }
  .content-container {
    .btn-nav {
      display: flex;
      justify-content: space-around;
      margin: 42px 0;
    }
    .winners-container {
      margin: 3.5vw 0;
      border-radius: 25px;
      box-shadow: 0px 3px 5px 5px #ccc;
      .winners-top {
        border-bottom: solid 2px #85c357;
        line-height: 5vw;
        .date-btn {
          width: 11vw;
          line-height: 3vw;
          border: solid 2px;
          display: inline-block;
          text-align: center;
          margin-left: 2.4vw;
          color: #229fd8;
          cursor: pointer;
        }
        .active {
          background: #229fd8;
          color: white;
        }
      }
      .winners-info {
        & > li {
          height: 18.6vw;
          display: flex;
          border-bottom: solid 1px #e5e7e8;
          .winners-info-photo {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 21vw;
            height: 100%;
            & > img {
              width: 10vw;
              height: 10vw;
              border-radius: 50%;
              border: solid 0.3vw #85c357;
              transition: all ease-in-out 1s;
            }
          }
          .winners-info-content {
            padding: 2vw 0;
            .name {
              font-size: 1.8vw;
              color: #85c357;
              font-weight: 600;
            }
            .source {
              line-height: 3.9vw;
              font-size: 1.3vw;
              color: #575a5a;
            }
            .more-info {
              width: 9.4vw;
              line-height: 3.4vw;
              text-align: center;
              background: #85c357;
              color: white;
              margin-top: 3.5vw;
              cursor: pointer;
            }
          }
        }
      }
      .winners-bottom {
        padding: 3.2vw 0;
        .more-btn {
          width: 11.3vw;
          line-height: 3.3vw;
          background: #229fd8;
          text-align: center;
          color: white;
          margin: 0 auto;
          cursor: pointer;
        }
      }
    }
  }
  .submit-container-bg {
    width: 100%;
    background: #f3f3f3;
    padding: 4vw 3vw;
    box-sizing: border-box;
    margin-top: 5vw;
    max-width: unset;
    .submit-container {
      max-width: 1200px;
      margin: 0 auto;
      .title {
        margin: 0;
      }
      .date {
        line-height: 8.5vw;
        font-size: 23px;
        font-weight: 600;
      }
      .submit-item-container {
        display: flex;
        justify-content: space-around;
        align-items: top;
        .submit-item {
          width: 50%;
          background: white;
          border-radius: 1vw;
          display: inline-block;
          position: relative;
          overflow: hidden;
          text-align: center;
          max-width: 450px;
          padding: 0 1vw 5vw;
          &::after {
            content: "";
            width: 5vw;
            height: 6.5vw;
            background: #229fd8;
            position: absolute;
            left: -3.2vw;
            top: -3.2vw;
            transform: rotate(45deg);
          }
          &:last-child {
            margin-left: 2.4vw;
          }
          .title {
            font-size: 23px;
            height: 90px;
            display: flex;
            align-items: center;
            color: #229fd8;
          }
          .border {
            width: 35.2vw;
            height: 0.2vw;
            background: #229fd8;
            margin: 0 auto 2.2vw;
          }
          .con {
            margin: 0 auto;
            padding: 0 2vw 2vw;
            text-align: left;
          }
          .tag {
            position: absolute;
            bottom: 2%;
            left: 7.4%;
            width: 85%;
            background: #229fd8;
            padding: 0 3.6vw;
            box-sizing: border-box;
            font-size: 1.4vw;
            line-height: 3vw;
            color: white;
            cursor: pointer;
          }
          &:last-child::after {
            background: #85c357;
          }
          &:last-child {
            .title {
              color: #85c357;
            }
            .border,
            .tag {
              background: #85c357;
            }
          }
          .list-mark{
                left: 1.6vw;
                margin-top: 0.3vw;
                // top: 1vw;
            // padding: 0 1.6vw;
            // box-sizing: border-box;
            line-height: 24px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .ScholarshipArea {
    .banner {
      height: 40vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-image: url("../assets/img/winning/banner.jpg");
      background-size: cover;
      background-repeat: no-repeat;
      color: white;
      h1 {
        line-height: 14vw;
        font-size: 7vw;
      }
    }
    .content-container {
      width: 80.7vw;
      margin: 0 auto 4.4vw;
      font-size: 1.7vw;
      .title {
        color: #85c456;
        margin: 3.4vw auto 2.8vw;
        font-size: 7vw;
        & > span {
          border-bottom: solid 0.5vw #22a0d6;
          padding-bottom: 1vw;
        }
      }
      .winners-container {
        margin-top: 3.5vw;
        border-radius: 25px;
        box-shadow: 0px 3px 5px 5px #ccc;
        .winners-top {
          border-bottom: solid 2px #85c357;
          line-height: 15vw;
          font-size: 4vw;
          .date-btn {
            width: 25vw;
            line-height: 7vw;
            border: solid 2px;
            display: inline-block;
            text-align: center;
            margin-left: 2.4vw;
            color: #229fd8;
            cursor: pointer;
          }
          .active {
            background: #229fd8;
            color: white;
          }
        }
        .winners-info {
          & > li {
            height: 25vw;
            display: flex;
            border-bottom: solid 1px #e5e7e8;
            .winners-info-photo {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 25vw;
              height: 100%;
              & > img {
                width: 20vw;
                height: 20vw;
                border-radius: 50%;
                border: solid 0.3vw #85c357;
                transition: all ease-in-out 1s;
              }
            }
            .winners-info-content {
              padding: 2.5vw 0;
              .name {
                font-size: 3vw;
                color: #85c357;
                font-weight: 600;
              }
              .source {
                line-height: 4vw;
                font-size: 3.5vw;
                color: #575a5a;
              }
              .more-info {
                width: 12vw;
                line-height: 5.4vw;
                text-align: center;
                background: #85c357;
                color: white;
                margin-top: 2.5vw;
                cursor: pointer;
              }
            }
          }
        }
        .winners-bottom {
          padding: 3.2vw 0;
          .more-btn {
            width: 25vw;
            line-height: 8vw;
            background: #229fd8;
            text-align: center;
            color: white;
            margin: 0 auto;
            cursor: pointer;
            font-size: 3vw;
          }
        }
      }
    }

    .submit-container-bg {
      width: 100%;
      background: #f3f3f3;
      padding: 0;
      .submit-container {
        padding: 20px;
        .title {
          margin: 0;
        }
        .date {
          line-height: 8.5vw;
          font-size: 3vw;
        }
        .submit-item-container {
          flex-wrap: wrap;
          .submit-item {
            width: 100%;
            background: white;
            border-radius: 1vw;
            display: inline-block;
            position: relative;
            overflow: hidden;
            text-align: center;
            padding: 3vw;
            box-sizing: border-box;
            padding-bottom: 15%;
            .list-mark{
              margin-top: 4.3vw;
            }
            &::after {
              content: "";
              width: 6.5vw;
              height: 6.5vw;
              background: #229fd8;
              position: absolute;
              left: -3.2vw;
              top: -3.2vw;
              transform: rotate(45deg);
            }
            &:last-child {
              margin: 3vw 0 0 0;
            }
            .title {
              font-size: 5vw;
              line-height: 10vw;
              color: #229fd8;
            }
            .border {
              width: 35.2vw;
              height: 0.2vw;
              background: #229fd8;
              margin: 0 auto 2.2vw;
            }
            .con {
              width: 100%;
              font-size: 3vw;
              margin: 0 auto;
              padding: 4vw 2vw;
            }
            .tag {
              width: 45%;
              background: #229fd8;
              margin: 0 auto;
              padding: 2vw 3vw;
              height: auto;
              font-size: 3vw;
              line-height: 4vw;
              color: white;
              cursor: pointer;
              margin-left: 20%;
            }

            &:last-child::after {
              background: #85c357;
            }
            &:last-child {
              .title {
                color: #85c357;
              }
              .border,
              .tag {
                background: #85c357;
              }
            }
          }
        }
      }
    }
  }
}
</style>
